import * as React from "react";
const SvgArrowDropDown = props => <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48" {...props}><path d="m14 20 10 10 10-10z" /></svg>;
export { SvgArrowDropDown as ReactComponent };